

import { events } from 'aws-amplify/data';
import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';

export function useCharacterReceivableAlerts(charId: string, onReceive: (n: any) => void) {
  const auth = useAuth();
  const idToken = auth.user?.id_token;

  useEffect(() => {
    if (!charId || !idToken) return;
    // console.log('Amplify config at connect time:', Amplify.getConfig());

    let channel: Awaited<ReturnType<typeof events.connect>>;

    (async () => {
      try {
        channel = await events.connect(`/characterReceivable/${charId}`);
        channel.subscribe({
          next: (data) => onReceive(data.event),
          error: (err) => {
            console.error("Subscription error.");
            // console.error('Subscription error message:', err.message);
            // console.error('Recovery suggestion:', err.recoverySuggestion);
            // console.error('Underlying error:', err.underlyingError ?? err);
          },
        });
      } catch (err: any) {
        console.error("Subscription error.");
        // console.error('Connect error message:', err.message);
        // console.error('Recovery suggestion:', err.recoverySuggestion);
        // console.error('Underlying error:', err.underlyingError ?? err);
      }
    })();

    return () => channel?.close();
  }, [charId, idToken, onReceive]);
}

export function useCampaignReceivableAlerts(campaignId: string, onReceive: (n: any) => void) {
  const auth = useAuth();
  const idToken = auth.user?.id_token;

  useEffect(() => {
    if (!campaignId || !idToken) return;
    // console.log('Amplify config at connect time:', Amplify.getConfig());

    let channel: Awaited<ReturnType<typeof events.connect>>;

    (async () => {
      try {
        channel = await events.connect(`/campaignReceivable/${campaignId}`);
        channel.subscribe({
          next: (data) => {
            console.log(data);
            onReceive(data.event);
          },
          error: (err) => {
            console.error("Subscription error.");
            // console.error('Subscription error message:', err.message);
            // console.error('Recovery suggestion:', err.recoverySuggestion);
            // console.error('Underlying error:', err.underlyingError ?? err);
          },
        });
      } catch (err: any) {
        console.error("Subscription error.");
        // console.error('Connect error message:', err.message);
        // console.error('Recovery suggestion:', err.recoverySuggestion);
        // console.error('Underlying error:', err.underlyingError ?? err);
      }
    })();

    return () => channel?.close();
  }, [campaignId, idToken, onReceive]);
}

export function useUserReceivableAlerts(userId: string, onReceive: (n: any) => void) {
  const auth = useAuth();
  const idToken = auth.user?.id_token;

  useEffect(() => {
    if (!userId || !idToken) return;
    // console.log('Amplify config at connect time:', Amplify.getConfig());

    let channel: Awaited<ReturnType<typeof events.connect>>;

    (async () => {
      try {
        channel = await events.connect(`/userReceivable/${userId}`);
        channel.subscribe({
          next: (data) => onReceive(data.event),
          error: (err) => {
            console.error("Subscription error.");
            // console.error('Subscription error message:', err.message);
            // console.error('Recovery suggestion:', err.recoverySuggestion);
            // console.error('Underlying error:', err.underlyingError ?? err);
          },
        });
      } catch (err: any) {
        console.error("Subscription error.");
        // console.error('Connect error message:', err.message);
        // console.error('Recovery suggestion:', err.recoverySuggestion);
        // console.error('Underlying error:', err.underlyingError ?? err);
      }
    })();

    return () => channel?.close();
  }, [userId, idToken, onReceive]);
}

export function useCampaignsReceivableAlerts(
  campaignIds: string[],
  onReceive: (campaignId: string, n: any) => void
) {
  const auth = useAuth();
  const idToken = auth.user?.id_token;

  // Stable string key so effect doesn't re-run on every re-render
  // just because a new array instance with the same ids was passed in.
  const idsKey = [...campaignIds].sort().join(",");

  useEffect(() => {
    if (campaignIds.length === 0 || !idToken) return;

    let cancelled = false;
    const channels = new Map<string, Awaited<ReturnType<typeof events.connect>>>();

    console.log(campaignIds);
    (async () => {
      await Promise.all(
        campaignIds.map(async (campaignId) => {
          try {
            const channel = await events.connect(`/campaignReceivable/${campaignId}`);

            if (cancelled) {
              // campaignIds changed (or component unmounted) before this
              // particular connect() resolved — don't leak the channel.
              channel.close();
              return;
            }

            channels.set(campaignId, channel);

            channel.subscribe({
              next: (data) => {
                console.log(data);
                onReceive(campaignId, data.event);
              },
              error: (err) => {
                console.error(`Subscription error (campaign ${campaignId}).`);
              },
            });
          } catch (err: any) {
            console.error(`Subscription error (campaign ${campaignId}).`);
          }
        })
      );
    })();

    return () => {
      cancelled = true;
      channels.forEach((channel) => channel.close());
      channels.clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsKey, idToken, onReceive]);
}